<mat-card class="flex flex-col p-8 space-y-4 w-[22vw]">
	<mat-card-title>New Quote</mat-card-title>
	<mat-form-field appearance="outline" subscriptSizing="dynamic">
		<mat-label>Select Project</mat-label>
		<input matInput type="text" [matAutocomplete]="auto" [formControl]="projectControl" placeholder="Search Projects" />
		<mat-autocomplete #auto="matAutocomplete" [displayWith]="projectControlDisplay" (optionSelected)="onProjectSelection()">
			<mat-option *ngFor="let project of filteredProjects | async" [value]="project">
				{{ project.name }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
	<div class="flex flex-row place-content-center">
		<label>-- OR --</label>
	</div>
	<button mat-raised-button color="primary" (click)="newProject()">CREATE NEW PROJECT</button>
</mat-card>
